module.exports = __webpack_public_path__ + "img/IMG-20200519-WA0056.8ebf1dd4.jpg";